import React from 'react';
import { Box, Flex, Text, Button, Image, useColorModeValue } from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from 'contexts/AuthContext';
import { getDefaultDashboard } from 'routes';

const NotFound = () => {
    const navigate = useNavigate();
    const { user } = useAuth();
    const textColor = useColorModeValue('gray.800', 'white');
    const bgColor = useColorModeValue('white', 'gray.800');

    const goToDashboard = () => {
        if (user?.role) {
            navigate(getDefaultDashboard(user.role));
        } else {
            navigate('/auth/sign-in');
        }
    };

    return (
        <Flex direction="column" alignItems="center" justifyContent="center" h="100vh" bg={bgColor} p={8}>
            <Box mb={8}>
                <Text fontSize="6xl" fontWeight="bold" color={textColor} textAlign="center">
                    404
                </Text>
                <Text fontSize="2xl" fontWeight="medium" color={textColor} textAlign="center">
                    Page Not Found
                </Text>
            </Box>

            <Text fontSize="lg" color="gray.500" maxW="500px" textAlign="center" mb={8}>
                The page you're looking for doesn't exist or has been moved.
            </Text>

            <Button
                colorScheme="blue"
                size="lg"
                onClick={goToDashboard}
            >
                Go to Dashboard
            </Button>
        </Flex>
    );
};

export default NotFound;
